/**
 * @fileOverView
 * @description Vyb Full View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var VybFollowingTemplate = require('../../templates/widgets/vybfollowingtemplate.html');
var config = require("../../etc/config");
var app = require("ampersand-app");
var dialog = require("../../lib/dialog");
var Params = require("../../collections/params");
var ParamView = require("./param");

var VybFollowingView = AmpersandView.extend({

    template: VybFollowingTemplate,

    initialize: function(options){
        // Notification settings for sending (only shown when sendPermissions allows)
        this.notificationSettings = new Params([
            {
                "entity" : "vybfollowing",
                "name" : "message",
                "label" : "MESSAGE",
                "inputType" : "textarea",
                "template" : "TextAreaTemplate",
                "placeholder" : "notification message",
                "cursor" : true
            },
            {
                "entity" : "vybfollowing",
                "name" : "imageUrl",
                "label" : "IMAGE",
                "inputType" : "text",
                "template" : "TextTemplate",
                "placeholder" : "optional image url",
                "cursor" : true
            },
            {
                "entity" : "vybfollowing",
                "name" : "linkUrl",
                "label" : "LINK",
                "inputType" : "text",
                "template" : "TextTemplate",
                "placeholder" : "optional link url",
                "cursor" : true
            },
            {
                "entity" : "vybfollowing",
                "name" : "sendNotification",
                "label" : "",
                "inputType" : "button",
                "template" : "SendNotificationTemplate",
                "cursor" : true,
                "rightColContent" : '<div class="vcolright"><button class="btn btn-secondary btn-sm vclearfields">CLEAR FIELDS</button></div>'
            }
        ]);

        this.listenToAndRun(this.model,'change:sendPermissions',function(){
            this.renderNotificationSettings();
        });

        this.listenToAndRun(this.model,'change:accessStatus',function(){
            this.renderNotificationSettings();
        });
    },

    render: function(){
        this.renderWithTemplate();
        this.renderNotificationSettings();
        app.utils.clipboard();
    },

    renderNotificationSettings: function(){
        const notifContainer = this.query('div.vset-notification');
        if (!notifContainer) return;

        // Get the entire notification accordion section and spacer
        const notifSection = this.query('#notification-section').parentElement;
        const spacer = notifSection.nextElementSibling;

        // Only show notification settings if:
        // 1. sendPermissions allows subscriber sends AND
        // 2. subscriber has accepted (accessStatus is not 'invited')
        const hasPermissions = this.model.sendPermissions === 'subs_owner' || this.model.sendPermissions === 'subs_group';
        const hasAccepted = this.model.accessStatus !== 'invited';

        if (hasPermissions && hasAccepted) {
            notifSection.classList.remove('vhide');
            if (spacer && spacer.classList.contains('vsettings-spacer')) {
                spacer.classList.remove('vhide');
            }
            this.renderCollection(this.notificationSettings,ParamView,'div.vset-notification');

            // Update button text based on sendPermissions
            const sendButton = this.query('button.vybsend');
            if (sendButton) {
                sendButton.textContent = this.model.sendButtonText;
            }
        } else {
            notifSection.classList.add('vhide');
            if (spacer && spacer.classList.contains('vsettings-spacer')) {
                spacer.classList.add('vhide');
            }
        }
    },

    bindings: {
        "model.vybName": {
            type: 'text',
            hook: 'name'
        },

        "model.description": {
            type: 'text',
            hook: 'description'
        },

        "model.ownerName": {
            type: 'text',
            hook: 'owner'
        },
        "model.onOff": {
            type: 'booleanAttribute',
            hook: 'onOff',
            name: 'checked'
        },
        "model.switchKeyInput": {
            type: "attribute",
            selector: "input",
            name: "id"
        },
        "model.switchKeyLabel": {
            type: "attribute",
            selector: "label.vswitchlabel",
            name: "for"
        },
        "model.soundName": {
            type: 'innerHTML',
            hook: 'soundName'
        },
        "model.buttonDisplay": {
            type: 'innerHTML',
            hook: 'button'
        },

        "model.declineButtonDisplay": {
            type: 'booleanClass',
            hook: 'decline',
            name: 'vhide'
        },
        "model.hideSubscriptionLinks": {
            type: 'booleanClass',
            selector: '#subscriptionLinks',
            name: 'vhide'
        },
        "model.subscriptionLinks": {
            "type" : "innerHTML",
            "hook" : "subscriptionLinks"
        },
        "model.subscriptionCopyButtons" : {
            "selector" : "div.vsubcopy",
            "type" : "innerHTML"
        },
        //sound img shake
        "model.shakeElement" : {
            type : "booleanClass",
            name : "vybshake",
            selector : "img.vdeltaimg"
        },
        "model.sendButtonText": {
            type: 'text',
            hook: 'sendButton'
        }

    },

    events: {
        "click label.vswitchlabel" : "setStatus",
        "click button.vybdelete" : "unfollowVyb",
        "click button.vybaccept" : "acceptInvite",
        "click button.vybdecline" : "declineInvite",
        "click img.vdeltaimg, .vdeltaclick" : "playSound",
        "click .vclearfields" : "clearNotificationFields"
    },

    executeSendNotification: function(event){
        if(event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const message = this.model.message || '';
        const imageUrl = this.model.imageUrl || '';
        const linkUrl = this.model.linkUrl || '';

        if(!message && !imageUrl && !linkUrl){
            dialog.alert('Please provide at least a message, image, or link');
            return;
        }

        const endpoint = this.model.sendPermissions === 'subs_owner' ? 'send-to-owner' : 'send-to-group';
        const url = `${app.config.restApiUrl}/vyb/subscriber/${this.model.key}/${endpoint}`;

        const payload = {
            imageUrl: imageUrl,
            linkUrl: linkUrl
        };
        if(message) payload.message = message;

        const authHeaders = app.utils.setPersonalAuthTokenHeader().headers;

        fetch(url, {
            method: 'POST',
            headers: {
                ...authHeaders,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return response.json();
        })
        .then(data => {
            // result 0: received but not sent (limit reached or vybit off), warn says why
            if (data.result === 0) {
                dialog.alert(data.warn || 'Notification was not sent');
                return;
            }
            app.pageSwitcher.set(new app.LogPageView());
        })
        .catch(error => {
            dialog.alert('Error sending notification: ' + (error.message || 'Unknown error'));
        });
    },

    setStatus: function(){
        var status = this.model.status=="on" ? "off" : "on";
        this.model.save({status:status},
            {
                patch:true,
                wait: true,

                success: function(model,response){
                    console.log('status changed to: ' + model.status);
                },
                error: function(model,response){
                    console.log('error changing status');
                }
            });
    },

    acceptInvite: function(){
        this.model.save({accessStatus:"granted"},
            {
                patch:true,

                success: function(model,response){
                    app.loadLogs(true);
                }
            });

    },

    unfollowVyb: async function(){
        if(await dialog.confirm('Unfollow this vybit?', {title: 'Unfollow vybit', okText: 'Unfollow', danger: true})){
            console.log('unfollowing ' + this.model.key);
            this.model.destroy();
            app.pageSwitcher.set(new app.LogPageView());
        }
    },

    declineInvite: async function(){
        console.log('clicked decline');
        if(await dialog.confirm('Decline the invitation to follow this vybit?', {title: 'Decline invitation', okText: 'Decline', danger: true})){
            console.log('declining');
            this.model.destroy({
                url: this.model.url() + '?action=decline'
            });
            app.pageSwitcher.set(new app.LogPageView());
        }
    },

    playSound: function(){
        this.model.set('pinging',true);
        app.soundViews[this.model.soundKey] = this.model;
        app.utils.playSound(this.model.soundKey);
    },

    clearNotificationFields: function(event){
        if(event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const fields = {message: '', imageUrl: '', linkUrl: ''};

        this.model.set(fields, {silent: true});

        Object.keys(fields).forEach(function(field){
            this.model.trigger('change:' + field, this.model, '');
        }, this);

        this.model.save(fields, {patch: true, silent: true});
    }
});

module.exports = VybFollowingView;
